import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Badge, OverlayTrigger } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import Edit from '@material-ui/icons/Edit';
import StatusBadge from '../../../components/common/StatusBadge';
import FilterMultiSelect from '../../../components/table/FilterMultiSelect';
import { state_ru, status_ru } from '../../../helpers/buy';
import { floatRenderer } from '../../../services/formatSvc';
import { getLookupObject } from '../../../utils/table';
import PopoverElement from '../../../components/common/PopoverElement';
import { getPathType } from '../../../helpers/typeProject';

const stickyCellStyle = {
  background: 'inherit',
  position: 'sticky',
  left: 0,
  zIndex: 11,
};

export const getColumns = (filters, sourceType, reportType, actions, year, strategyType) => {
  const isSourceSf = sourceType === 'sf';
  const onProj = reportType === 'onProj';
  const onPortf = reportType === 'onPortf';
  const onStrat = reportType === 'onStrat';
  const isNew = strategyType
    ? year >= 2025 && (strategyType === 'goal' || strategyType === 'tech')
    : year >= 2025;

  return [
    {
      title: '№ закупки',
      field: 'num',
      lookup: filters.num,
      filterComponent: FilterMultiSelect,
      minWidth: '200px',
      headerStyle: { ...stickyCellStyle },
      filterCellStyle: { ...stickyCellStyle },
      cellStyle: { ...stickyCellStyle, zIndex: 9, boxShadow: '1px 4px 4px rgba(0,0,0,0.30)' },
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Название закупки',
      field: 'name',
      minWidth: '250px',
      render: (rowData) => <NavLink to={`/${getPathType(rowData.strategy?.type)}/${rowData.strategyId}/projs/${rowData.projId}/buys/${rowData.id}`}>{rowData.name}</NavLink>,
    },
    {
      title: 'Версия закупки',
      field: 'version',
    },
    {
      title: 'Статус',
      field: 'status',
      lookup: filters.status,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      render: ({ status }) => <StatusBadge type="buy" status={status} width={150} />,
      _meta: {
        lookup: true,
        lookupLabelsDictionary: status_ru,
      },
    },
    {
      title: 'Состояние',
      field: 'state',
      lookup: filters.state,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      render: ({ state }) => <StatusBadge type="buyState" status={state} width={150} />,
      _meta: {
        lookup: true,
        lookupLabelsDictionary: state_ru,
      },
    },
    {
      title: 'Отправлено в 1С',
      field: 'isExported',
      lookup: filters.isExported,
      filterComponent: FilterMultiSelect,
      minWidth: '180px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ СП',
      field: 'strategyNum',
      hidden: onProj || onStrat || onPortf,
      lookup: filters.strategyNum,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ проекта',
      field: 'projNum',
      hidden: onProj,
      lookup: filters.projNum,
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Наименование проекта',
      field: 'projName',
      hidden: onProj,
      lookup: filters.projName,
      filterComponent: FilterMultiSelect,
      minWidth: '300px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Руководитель проекта',
      field: 'projHead',
      hidden: onProj,
      lookup: filters.projHead,
      filterComponent: FilterMultiSelect,
      minWidth: '150px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Соглашение',
      field: 'agreement',
      hidden: isSourceSf,
      lookup: filters.agreement,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'КБК',
      field: 'bcCode',
      hidden: isSourceSf,
      lookup: filters.bcCode,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Тип финансирования',
      field: 'funding',
      lookup: filters.funding,
      filterComponent: FilterMultiSelect,
      hidden: isNew,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Вид расходов',
      field: 'expenseType',
      hidden: isSourceSf,
      lookup: filters.expenseType,
      filterComponent: FilterMultiSelect,
      minWidth: '240px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ статьи соглашения',
      field: 'costAgr',
      hidden: isSourceSf,
      lookup: filters.costAgr,
      filterComponent: FilterMultiSelect,
      minWidth: '220px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Введено по закупке, руб.',
      field: 'draftSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ draftSum }) => floatRenderer(draftSum),
    },
    {
      title: 'Утверждено на комиссии, руб.',
      field: 'approvedSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ approvedSum }) => floatRenderer(approvedSum),
    },
    {
      title: 'Акцепт, руб.',
      field: 'acceptedSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ acceptedSum }) => floatRenderer(acceptedSum),
    },
    {
      title: 'Контракт, руб.',
      field: 'contractSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ contractSum }) => floatRenderer(contractSum),
    },
    {
      title: 'Оплата, руб.',
      field: 'paymentSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ paymentSum }) => floatRenderer(paymentSum),
    },
    {
      title: 'Проблемная закупка',
      field: 'hasProblem',
      minWidth: '180px',
      lookup: filters.hasProblem,
      filterComponent: FilterMultiSelect,
      render: ({
        id, hasProblem, problemDescr, problemType, problemComment,
      }) => (hasProblem === 'Да'
        ? (
          <div style={{ textAlign: 'center' }}>
            <PopoverElement tooltip={(onStrat || onProj || onPortf) ? (problemComment ?? problemType) : problemDescr}>
              <Badge pill bg="danger" style={{ marginLeft: '5px' }}>!</Badge>
            </PopoverElement>
          </div>
        )
        : <div />),
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Тип проблемы',
      field: 'problemType',
      minWidth: '200px',
      lookup: filters.problemType,
      hidden: onProj || onStrat || onPortf,
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Комментарий',
      field: 'problemComment',
      minWidth: '280px',
      hidden: onProj || onStrat || onPortf,
      render: ({
        id, hasProblem, otherProblem, problemComment,
      }) => (
        <>
          {(hasProblem === 'Да' || !!otherProblem) && actions
          && (
          <Tooltip title="Изменить комментарий">
            <IconButton
              onClick={() => actions.showCommentModal(id, problemComment)}
              aria-label="Изменить комментарий"
              style={{ order: 2 }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
          )}
          {problemComment}
        </>
      ),
    },
    {
      title: 'Иная проблема',
      field: 'otherProblem',
      lookup: filters.otherProblem,
      hidden: onProj || onStrat || onPortf,
      filterComponent: FilterMultiSelect,
      render: ({ id, num, otherProblem }) =>
        <Checkbox disabled={!actions} checked={!!otherProblem} onChange={(e) => actions.showOtherProblemModal(id, num, !otherProblem)} />,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Протокол',
      field: 'protocol',
      minWidth: '160px',
    },
    {
      title: 'Портфель',
      field: 'portfName',
      hidden: onProj || onPortf,
      lookup: filters.portfName,
      minWidth: '250px',
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
  ];
};

export const getFilters = (data) => {
  const columnsMetadata = getColumns({})
    .filter((col) => col._meta && col._meta.lookup)
    .map((col) => ({ field: col.field, lookupLabelsDictionary: col._meta.lookupLabelsDictionary }));

  return columnsMetadata.reduce((acc, col) => {
    const result = getLookupObject(data, col.field);
    if (col.lookupLabelsDictionary) {
      for (const key of Object.keys(result)) result[key] = col.lookupLabelsDictionary[key];
    }

    return { ...acc, [col.field]: result };
  }, {});
};
